<template>
  <div ref="questionProgressBar" class="trbo-a-question-progress-bar" :style="styles">
    <div class="trbo-a-question-progress-bar__shadow" :style="shadowStyles">
      <div class="trbo-a-question-progress-bar__shadow__dot" />
    </div>
    <div class="trbo-a-question-progress-bar__items" :style="itemsStyles">
      <question-progress-bar-item
        v-for="(item, index) of settings.items"
        :key="item.id"
        :wizard-page="item"
        :completed="true"
        :current="index === (settings.items.length - 1)"
        @click="onItemClick"
      />
    </div>
  </div>
</template>

<script>
// @flow

import { progressBarItemLabelWidth } from '../../../../common/utils/progressBar'

import QuestionProgressBarItem from './QuestionProgressBarItem.vue'

export default {
  components: {
    QuestionProgressBarItem
  },
  props: {
    settings: {
      type: Object, // QuestionProgressBarSettings
      required: true
    }
  },
  data () {
    return {
      maxLabelWidth: 0
    }
  },
  computed: {
    styles () {
      return { '--max-label-width': `${this.maxLabelWidth}px` }
    },
    shadowStyles () {
      return this.getStyles(true)
    },
    itemsStyles () {
      return this.getStyles()
    }
  },
  watch: {
    'settings.progress' () {
      this.$nextTick(() => {
        this.calculateMaxLabelWidth()
      })
    }
  },
  mounted () {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
      this.onResize()
    })
  },
  destroyed () {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    onItemClick (item) {
      this.$emit('progress-bar-item-click', item)
    },
    getStyles (addExtraSpace) {
      const { progress } = this.settings
      let width = '16px'
      if (progress === 100) {
        width = `${progress}%`
      } else if (progress > 0) {
        if (addExtraSpace) {
          width = `calc(${progress}% + 8px)`
        } else {
          width = `${progress}%`
        }
      }
      return { width }
    },
    onResize () {
      this.calculateMaxLabelWidth()
    },
    calculateMaxLabelWidth () {
      this.maxLabelWidth = progressBarItemLabelWidth(this.settings.progress, this.$refs.questionProgressBar.offsetWidth, this.settings.items.length)
    }
  }
}
</script>

<style scoped src="./question-progress-bar.scss" />
